import type { FC } from "react";

import type { BaseIconProps } from "@/assets/icons/utils";

export const IconPanelRightOpen: FC<BaseIconProps> = ({ size, className }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.75 2.75V13.25M6.83333 9.75L5.08333 8L6.83333 6.25M3.91667 2.75H12.0833C12.7277 2.75 13.25 3.27233 13.25 3.91667V12.0833C13.25 12.7277 12.7277 13.25 12.0833 13.25H3.91667C3.27233 13.25 2.75 12.7277 2.75 12.0833V3.91667C2.75 3.27233 3.27233 2.75 3.91667 2.75Z"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.25 3.25V16.75M8.5 12.25L6.25 10L8.5 7.75M4.75 3.25H15.25C16.0784 3.25 16.75 3.92157 16.75 4.75V15.25C16.75 16.0784 16.0784 16.75 15.25 16.75H4.75C3.92157 16.75 3.25 16.0784 3.25 15.25V4.75C3.25 3.92157 3.92157 3.25 4.75 3.25Z"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.5 4.5V19.5M10.3333 14.5L7.83333 12L10.3333 9.5M6.16667 4.5H17.8333C18.7538 4.5 19.5 5.24619 19.5 6.16667V17.8333C19.5 18.7538 18.7538 19.5 17.8333 19.5H6.16667C5.24619 19.5 4.5 18.7538 4.5 17.8333V6.16667C4.5 5.24619 5.24619 4.5 6.16667 4.5Z"
                        stroke="currentColor"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
